import {
  Component,
  OnInit,
  ViewContainerRef,
  ViewChild,
  ElementRef,
} from '@angular/core';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import htmlToPdfmake from 'html-to-pdfmake';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import {
  AlgConsensoService,
  REQUEST_STATUS_INVALID,
  REQUEST_STATUS_OK,
} from '../../services/alg-consenso.service';
import { Subject } from 'rxjs/Subject';
import {
  map,
  takeUntil,
  first,
  startWith,
  distinctUntilChanged,
} from 'rxjs/operators';
import { logoCoop, accendiLogo } from '../../../assets/js/base64Loghi';
import { UtilsService } from '../../services/utils.service';
import { ModalDialogService } from 'ngx-modal-dialog';
import { AlgOtpModalComponent } from '../../components/dialogs/alg-otp-modal/alg-otp-modal.component';
import { Autoricarica, AutoricaricaType } from '../../models/fisso';
@Component({
  selector: 'alg-autoricarica-component',
  templateUrl: './alg-autoricarica.component.html',
  styleUrls: ['./alg-autoricarica.component.scss'],
})
export class AlgAutoricaricaComponentComponent implements OnInit {
  public isLoading$: Observable<boolean>;
  public idRichiesta: string;
  public typeRichiesta: string;
  public supplies: Array<string>;
  public isActivationRequest: boolean;
  public consentsWithAdditionalProperty: any;
  public phone: string;
  public secondStep: boolean;
  public autoricarica: Autoricarica = {} as Autoricarica;
  public isOtpChecked: boolean;
  public urlExpired: boolean;
  public urlParams: any;
  public supplyCommodities: any;
  public listTypeSupply = [];
  public supplyLight = [];
  public supplyGas = [];
  public checkOtpDate: string;
  public isDesktop: boolean = true;

  private ngUnsubscribe = new Subject<void>();

  // OBSERVABLE TO WATCH REQUEST STATUS
  public isRequestOk$: Observable<boolean>;
  public isErrorGeneric$: Observable<boolean>;

  public actualWidth: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private consensoService: AlgConsensoService,
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef
  ) {
    this.isLoading$ = this.consensoService.isLoading$;
  }

  @ViewChild('pdfTable') pdfTable: ElementRef;

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.idRichiesta = params.idRichiesta;
      this.supplies = params.supplies.split(',');

      this.urlParams = {
        id: this.idRichiesta,
        supplies: this.supplies,
      };

      this.consensoService.fetchAutoricarica(this.urlParams);
      this.consensoService.fetchAutoricaricaSupplies(this.supplies);
    });

    this.actualWidth = window.innerWidth;

    if (this.actualWidth <= 767) {
      this.isDesktop = false;
    }

    this.consensoService.autoricaricaSupplyRequest$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((request) => {
        this.supplyCommodities = request;
        this.supplyCommodities.forEach((singleSupply) => {
          if (!this.listTypeSupply.includes(singleSupply.commodityType)) {
            this.listTypeSupply.push(singleSupply.commodityType);
          }
          if (
            singleSupply.commodityType === 'GAS' &&
            !this.supplyGas.includes(singleSupply.supplyCode)
          ) {
            this.supplyGas.push(singleSupply.supplyCode);
          }
          if (
            singleSupply.commodityType === 'LIGHT' &&
            !this.supplyLight.includes(singleSupply.supplyCode)
          ) {
            this.supplyLight.push(singleSupply.supplyCode);
          }
        });
      });

    this.consensoService.autoricaricaRequest$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((request) => {
        this.autoricarica = request;
        if (this.autoricarica.typeRequest === AutoricaricaType.activation) {
          this.isActivationRequest = true;
        } else {
          this.isActivationRequest = false;
        }

        if (request.otpValidateRequest === false) {
          this.urlExpired = true;
        } else {
          this.urlExpired = false;
        }

        this.isRequestOk$ =
          this.consensoService.autoricaricaRequestStatus$.pipe(
            map((request) => request === REQUEST_STATUS_OK),
            startWith(false),
            distinctUntilChanged()
          );

        this.isErrorGeneric$ =
          this.consensoService.autoricaricaRequestStatus$.pipe(
            map((request) => request === REQUEST_STATUS_INVALID),
            startWith(false),
            distinctUntilChanged()
          );
        this.isOtpChecked = this.autoricarica.Alg_OTPCheck__c;
      });

    this.consensoService.otpTimeCheck$.subscribe((time) => {
      this.checkOtpDate = this.setFormatDate(time);
      this.consensoService.isSecondStepAutoricarica$.subscribe((step) => {
        this.secondStep = step;
        if (this.secondStep) {
          this.consensoService.autoricaricaRequest$
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((request) => {
            console.log('SECOND REQUEST', request);
            this.autoricarica = request;
          });
          setTimeout(() => {
            this.uploadPDFToSharepoint();
          }, 500);
        }
      });
    });
  }

  public setFormatDate(oldDate: string) {
    const arrayDate = oldDate.split('T');
    const tmpHour = arrayDate[1].split('.');
    const tmpDay = arrayDate[0];
    const getHour = tmpHour[0];
    const arrayDay = tmpDay.split('-');
    const day = arrayDay[2];
    const month = arrayDay[1];
    const year = arrayDay[0];

    const newDate = `${day}/${month}/${year} ${getHour}`;

    return newDate;
  }

  public openOTPmodal() {
    this.consentsWithAdditionalProperty = {
      requestId: `${this.idRichiesta}`,
      requestType: `${this.typeRichiesta}`,
      Alg_OTPCheck__c: false,
      Alg_OTPCheckDate__c: '',
      Alg_OTPPhone__c: '',
      phone: `${this.autoricarica['phone']}`,
    };

    this.modalDialogService.openDialog(this.viewContainer, {
      title: 'Un ultimo passo: verifica il tuo numero di cellulare',
      childComponent: AlgOtpModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: 'modal-title modal-title-underline textCenter',
      },
      data: {
        isConsentsOk: true,
        consents: this.consentsWithAdditionalProperty,
        phone: `${this.autoricarica['phone']}`,
        linear: false,
        consensoType: 'autoricarica',
      },
    });
  }

  public uploadPDFToSharepoint() {
    console.log('CHECKTIME', this.checkOtpDate);
    const pdfTable = this.pdfTable.nativeElement;
    let file: FormData = new FormData();

    var html = htmlToPdfmake(pdfTable.innerHTML, {
      defaultStyles: {
        p: {
          margin: [-2, -2, -2, -2],
        },
        li: {
          margin: [0, 2, 2, 2],
          padding: [0, 0, 2, 0],
        },
        a: {
          color: 'black',
          decoration: '',
        },
      },
    });
    const documentDefinition = {
      content: [
        {
          columns: [
            { image: `${accendiLogo}`, fit: [80, 80], alignment: 'left' },
            { image: `${logoCoop}`, fit: [80, 80], alignment: 'right' },
          ],
        },

        html,
      ],
      pageSize: {
        width: 600,
        height: 'auto',
      },
      pageMargins: [30, 20, 30, 20],
      styles: {
        'pre-title': {
          alignment: 'center',
          background: '#eeece1',
          bold: true,
        },
        'main-title': {
          alignment: 'center',
          background: '#eeece1',
        },
        privacy: {
          bold: true,
        },
      },
    };
    const pdfFile = pdfMake.createPdf(documentDefinition);

    pdfFile.getBlob((blob) => {
      file.append('pdfFile', blob, `${this.autoricarica.codeRequest}`);
      this.consensoService.uploadAutoricaricaRequest(file);
    });
  }

  public downloadPdf() {
    const pdfTable = this.pdfTable.nativeElement;

    var html = htmlToPdfmake(pdfTable.innerHTML, {
      defaultStyles: {
        p: {
          margin: [-2, -2, -2, -2],
        },
        li: {
          margin: [0, 2, 2, 2],
          padding: [0, 0, 2, 0],
        },
        a: {
          color: 'black',
          decoration: '',
        },
      },
    });
    const documentDefinition = {
      content: [
        {
          columns: [
            { image: `${accendiLogo}`, fit: [80, 80], alignment: 'left' },
            { image: `${logoCoop}`, fit: [80, 80], alignment: 'right' },
          ],
        },

        html,
      ],
      pageSize: {
        width: 600,
        height: 'auto',
      },
      pageMargins: [30, 20, 30, 20],
      styles: {
        'pre-title': {
          alignment: 'center',
          background: '#eeece1',
          bold: true,
        },
        'main-title': {
          alignment: 'center',
          background: '#eeece1',
        },
        privacy: {
          bold: true,
        },
      },
    };

    // pdfMake.createPdf(documentDefinition).download();

    if (this.isDesktop) {
      pdfMake.createPdf(documentDefinition).open({}, window.open('', '_blank'));
    } else {
      pdfMake.createPdf(documentDefinition).open({}, window);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/alg-autoricarica/alg-autoricarica.component.ts